import { isEmpty, lowerCase } from "lodash";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";

const VENDOR_BASE = "https://jiliwin.9terawolf.com/images/jaya9/vendor-card";

const TABS = [
  { key: "hot", labelKey: "HotGames", icon: `/static/svg/mobileMenu/Hot.svg` },
  {
    key: "cricket",
    labelKey: "Cricket",
    icon: `/static/svg/mobileMenu/cricket.png`,
  },
  { key: "ld", labelKey: "Casino", icon: `/static/svg/mobileMenu/ld.png` },
  { key: "rng", labelKey: "Slot", icon: `/static/svg/mobileMenu/rng.png` },
  { key: "table", labelKey: "Table", icon: `/static/svg/mobileMenu/table.png` },
  { key: "sb", labelKey: "Sports", icon: `/static/svg/mobileMenu/sb.png` },
  {
    key: "fishing",
    labelKey: "Fishing",
    icon: `/static/svg/mobileMenu/fishing.png`,
  },
  { key: "crash", labelKey: "Crash", icon: `/static/svg/mobileMenu/crash.png` },
];

const HOT_BANNERS = [
  {
    src: "/assets/hot/68ef8d419c4b3.webp",
    paddingBottom: "126.418%",
    contentWidth: "617px",
    hot: true,
    platFormCode: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
  },
  {
    src: "/assets/hot/688b426b6e0ac.webp",
    paddingBottom: "126.418%",
    contentWidth: "617px",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-001",
    hot: true,
  },
  {
    src: "/assets/hot/6607167682b93.webp",
    paddingBottom: "126.418%",
    contentWidth: "617px",
    hot: true,
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-029",
  },
  {
    src: "/assets/hot/6607168d94b6c.webp",
    paddingBottom: "126.418%",
    contentWidth: "617px",
    hot: true,
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-027",
  },
  {
    src: "/assets/hot/660713693ab53.webp",
    paddingBottom: "126.418%",
    contentWidth: "617px",
    hot: true,
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-006",
  },
  {
    src: "/assets/hot/660716d69eb51.webp",
    paddingBottom: "126.418%",
    contentWidth: "617px",
    hot: true,
    gameType: "LIVE",
    casinoType: "PP-LIVE-038",
    Name: "Mega Wheel",
    platFormCode: "PP",
  },
  {
    src: "/assets/hot/6607194c29201.webp",
    paddingBottom: "126.418%",
    contentWidth: "617px",
    hot: true,
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-183",
  },
  {
    src: "/assets/hot/aviator.webp",
    paddingBottom: "100%",
    contentWidth: "800px",
    hot: true,
    platFormCode: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-026",
  },
];

const ShowObject = {
  hot: "hot",
  cricket: "cricket",
  ld: "casino",
  rng: "slot",
  table: "table",
  sb: "sports",
  fishing: "fishing",
  crash: "crash",
};
const VENDORS = {
  cricket: [
    { id: "betswiz", name: "Velki", badge: "hot" },
    { id: "wicketspro", name: "9Wicket", badge: null },
  ],
  ld: [
    { id: "evo", name: "Evo", badge: "hot", key: "EVOLUTION" },
    { id: "pp2", name: "Pragmatic", badge: null, key: "PP" },
    { id: "sexy_v2", name: "Sexy", badge: "hot", key: "SEXY" },
  ],
  rng: [
    { id: "jili", name: "JILI", badge: "hot", key: "JILI" },

    { id: "pp2", name: "Pragmatic", badge: null, key: "PP" },
    { id: "pg", name: "PG", badge: null, key: "PG" },
    { id: "smart", name: "SmartSoft", badge: null, key: "SMARTSOFT" },
    { id: "spg", name: "Spade", badge: "hot", key: "SPADE" },
    { id: "fc", name: "FC", badge: null, key: "FC" },
    { id: "jdb", name: "JDB", badge: "new", key: "JDB" },
    { id: "rt", name: "Red Tiger", badge: null, key: "RT" },
  ],
  table: [
    { id: "jili", name: "JILI", badge: "hot", key: "JILI" },
    { id: "spribe", name: "Spribe", badge: "new", key: "SPRIBE" },

    { id: "pp2", name: "Pragmatic", badge: null, key: "PP" },
    { id: "km", name: "KingMidas", badge: null, key: "KM" },
    { id: "rt", name: "Red Tiger", badge: null, key: "RT" },
  ],
  sb: [{ id: "ibc", name: "IBC", badge: null }],
  fishing: [
    { id: "jili", name: "JILI", badge: "hot", key: "JILI" },

    { id: "spg", name: "Spade", badge: "hot", key: "SPADE" },
  ],
  crash: [
    { id: "aviator", name: "Aviator Studio", badge: null, key: "AVIATOR" },
    { id: "evo", name: "Evo", badge: "hot", key: "EVOLUTION" },
    { id: "jili", name: "JILI", badge: "hot", key: "JILI" },
    { id: "pp2", name: "Pragmatic", badge: null, key: "PP" },
    { id: "spribe", name: "Spribe", badge: "new", key: "SPRIBE" },
    { id: "km", name: "KingMidas", badge: null, key: "KM" },
    { id: "pg", name: "PG", badge: null, key: "PG" },
    { id: "smart", name: "SmartSoft", badge: null, key: "SMARTSOFT" },
  ],
};

const badgeIcon = (badge) =>
  badge === "hot"
    ? `/static/image/icon/hot-icon.png`
    : badge === "new"
      ? `/static/image/icon/new_icon.png`
      : null;

export default function GameMenu() {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState("hot");
  const launchCasino = useContextSelector(AuthContext, (ctx) => {
    return ctx.launchCasino;
  });
  const setLoginModalShow = useContextSelector(AuthContext, (ctx) => {
    return ctx.setLoginModalShow;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const navigate = useNavigate();
  const isHot = selectedTab === "hot";
  const vendors = VENDORS[selectedTab] || [];

  const handel = (res) => {
    if (!isEmpty(user)) {
      if (isEmpty(res?.platFormCode)) {
        toast.error(t("ComingSoon"));
      } else {
        if (!isEmpty(res?.gameid)) {
        } else {
          launchCasino({
            platForm: res?.platFormCode,
            gameType: res?.gameType,
            casinoType: res?.casinoType || res?.gameCode,
          });
        }
      }
    } else {
      setLoginModalShow(true);
    }
  };

  const Launch = (item) => {
    if (isHot) {
      handel(item);
    } else {
      if (selectedTab == "cricket") {
        if (item?.name == "Velki") {
          if (isEmpty(user)) {
            setLoginModalShow(true);
          } else {
            navigate("/sports-velki");
          }
        } else if (item?.name == "9Wicket") {
          if (isEmpty(user)) {
            setLoginModalShow(true);
          } else {
            if (isMobile) {
              navigate("/inplay-sky");
            } else {
              navigate("/sports-sky");
            }
          }
        } else {
          handel(item);
        }
      } else {
        navigate(
          `/casino?type=${lowerCase(ShowObject[selectedTab])}&provider=${item?.key}`,
        );
      }
    }
  };
  return (
    <div className="game-menu d-md-none">
      <div id="game-menu" className="row no-gutters">
        <div
          id="game-menu-full"
          className="row game-menu-wrapper no-gutters"
          style={{ width: "100%" }}
        >
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => setSelectedTab(tab.key)}
              className={
                "v-btn v-btn--text theme--light v-size--default game-menu-content font-weight-bold caption" +
                (selectedTab === tab.key ? " selected" : "")
              }
              style={{ height: "auto" }}
            >
              <span className="v-btn__content">
                <div
                  className="game-menu-image"
                  style={{
                    "--src": `url('${tab.icon}')`,
                    ...(tab.key === "hot"
                      ? { width: "28px", height: "36px" }
                      : {}),
                  }}
                />
                <div className="game-menu-title">{t(tab.labelKey)}</div>
              </span>
            </button>
          ))}
        </div>
      </div>

      {isHot && (
        <div className="mt-0 hidden-md-and-up game-card-box px-4 py-2">
          <div className="game-card-box-wrapper hotgame">
            {HOT_BANNERS.map((banner, i) => (
              <div
                onClick={() => Launch(banner)}
                key={i}
                className="game-card-box-item gT_homepageHot"
              >
                <div className="v-image v-responsive banner-img theme--light homepageHot_img">
                  <div
                    className="v-responsive__sizer"
                    style={{ paddingBottom: banner.paddingBottom }}
                  />
                  <div
                    className="v-image__image v-image__image--contain"
                    style={{
                      backgroundImage: `url("${banner.src}")`,
                      backgroundPosition: "center center",
                    }}
                  />
                  <div
                    className="v-responsive__content"
                    style={{ width: banner.contentWidth }}
                  >
                    {banner.hot && (
                      <img
                        src={`/static/image/icon/hot-icon.png`}
                        className="img-hot-home pos_right_top"
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}
            <div
              id="autoFillEle1"
              className="game-card-box-item gT_homepageHot"
              style={{ maxHeight: "0px !important" }}
            >
              <div
                className="v-image v-responsive  banner-img theme--light"
                style={{ maxHeight: "0px" }}
              >
                <div
                  className="v-image__image v-image__image--preload v-image__image--cover"
                  style={{ backgroundPosition: "center center" }}
                />
                <div className="v-responsive__content" />
              </div>
            </div>
            <div
              id="autoFillEle2"
              className="game-card-box-item gT_homepageHot"
              style={{ maxHeight: "0px !important" }}
            >
              <div
                className="v-image v-responsive  banner-img theme--light"
                style={{ maxHeight: "0px" }}
              >
                <div
                  className="v-image__image v-image__image--preload v-image__image--cover"
                  style={{ backgroundPosition: "center center" }}
                />
                <div className="v-responsive__content" />
              </div>
            </div>
          </div>
        </div>
      )}

      {!isHot && (
        <div className="mt-0 hidden-md-and-up game-card-box px-4 py-2">
          <div className="game-card-box-wrapper">
            {vendors.map((vendor) => {
              const badgeSrc = badgeIcon(vendor.badge);
              return (
                <div
                  onClick={() => Launch(vendor)}
                  key={vendor.id}
                  className={`game-card-box-item gT_${selectedTab}`}
                >
                  <div
                    aria-label={vendor.id}
                    role="img"
                    className="v-image v-responsive game-card-image-avatar theme--light"
                    style={{ width: "auto" }}
                  >
                    <div
                      className="v-responsive__sizer"
                      style={{ paddingBottom: "100%" }}
                    />
                    <div
                      className="v-image__image v-image__image--contain"
                      style={{
                        backgroundImage: `url("${VENDOR_BASE}/${selectedTab}/${vendor.id}_avatar.png")`,
                        backgroundPosition: "center center",
                      }}
                    />
                    <div
                      className="v-responsive__content"
                      style={{ width: "150px" }}
                    >
                      {badgeSrc && (
                        <img
                          src={badgeSrc}
                          alt={vendor.badge}
                          className={
                            vendor.badge === "hot"
                              ? "img-hot-home pos_right_top"
                              : "img-new-home pos_right_top"
                          }
                        />
                      )}
                    </div>
                  </div>
                  <label className="text-capitalize d-flex justify-center holder_text">
                    {vendor.name}
                  </label>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
